export type CONTEXT_MARK = 'mentionContext'
export type MENTION_NODE = 'mention'

export const CONTEXT_MARK_TYPE = 'mentionContext'
export const MENTION_NODE_TYPE = 'mention'
